import { createApp } from 'vue'
import { createRouter, createWebHistory } from 'vue-router'
import CLPDashboard from './components/CLP/Dashboard'
import CLPSettings from './components/CLP/Settings'
import Users from './components/Users'
import Login from './components/Login'
import App from './components/App'
import NotFound from './components/404'
import MainHeader from './components/MainHeader'
import Loading from './components/Loading.vue'

/* Sales */
import SalesDashboard from './components/Sales/Dashboard'
import SalesSettings from './components/Sales/Settings'

import PersonSearch from './components/PersonSearch'

import axios from 'axios';
import { createPinia } from 'pinia';
import { useAuthStore } from './stores/auth.js';
import { createI18n } from "vue-i18n";

// import translations
import sv from "./locales/sv.json";
import no from "./locales/no.json";

// configure i18n
const i18n = createI18n({
  locale: "sv",
  fallbackLocale: "sv",
  messages: { sv, no },
});


const guard = function(to, from, next, privilege = false) {
    const auth = useAuthStore();
    axios.post('/api/checkAuthToken', {
      privilege
    },{
        headers: {
            'Authorization': 'Bearer ' + auth.token
          }
    }).then(response => {
        // Use the language from the user
        i18n.global.locale = response.data.language;

        next();
    }).catch(() => {
        // There was an error so redirect
        next({ name: 'Login' })
    })
  };


const routes = [
    { path: '/app', component: Login, name: 'Login' },
    { path: '/app/clp/settings', component: CLPSettings, name: 'CLPSettings', beforeEnter: (to, from, next) => { guard(to, from, next, 'edit_settings');}},
    { path: '/app/sales/settings', component: SalesSettings, name: 'SalesSettings', beforeEnter: (to, from, next) => { guard(to, from, next, 'edit_settings');}},
    { path: '/app/clp/users', component: Users, name: 'UserSettings', beforeEnter: (to, from, next) => { guard(to, from, next, 'edit_settings');}},
    { path: '/:pathMatch(.*)*', name: 'NotFound', component: NotFound },
    { path: '/app/clp/', component: CLPDashboard, beforeEnter: (to, from, next) => {
        guard(to, from, next);
    }},
    { path: '/app/sales/', component: SalesDashboard, beforeEnter: (to, from, next) => {
      guard(to, from, next);
  }}
  ]
    
  const router = createRouter({
    history: createWebHistory(),
    routes
  })



const pinia = createPinia()
const app = createApp({})
app.use(i18n);

app.use(pinia);
app.use(router);
app.component('App', App)
app.component('Login', Login)
app.component('MainHeader', MainHeader)
app.component('Loading', Loading)
app.component('PersonSearch', PersonSearch)
app.mount('#app')